(function (Way2web) {

    Way2web.config = {
        eventPrice: 160
    };

}(window.Way2web = window.Way2web || {}));
